<template>
   <div class="custom-image">
       <a :href="widget.targetUrl" target="_blank">
           <img :src="widget.imageUrl"/>
       </a>
   </div>
</template>

<script>
// import axios from 'axios';

export default {
    name: 'customImage',
    props: {
        widget: {
            type: Object,
            required: true,
        },
    },
    computed: {
        directoryUrl () {
            return this.$store.state.clientConfig.directoryUrl;
        },
    },
    data () {
        return {

        };
    },
    created () {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.custom-image{

        img {
            width:100%;
        }

    .responsiveContent{
        position: relative;
        overflow: hidden;
        padding-top: 56.25%;
        ::v-deep iframe{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
}
</style>
